/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import { useNavigate } from "react-router-dom";
import { toKebabCase } from "../../../utils/helperFunctions";
import DbSoftwareBuilds from "./DbSoftwareBuilds";
import OsBuilds from "./OsBuilds";

// The tab chain is stretched to the viewport so the grid inside a panel can
// claim whatever height is left below the tab list.
const fillHeight = {
  mainBox: {
    ...tabbedDataGridPage.mainBox,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  tabContainer: {
    ...tabbedDataGridPage.tabContainer,
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  tabPanel: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    paddingLeft: "4px",
    // `display: flex` above would override the browser's [hidden] rule and
    // make the inactive panel claim flex space — keep it collapsed.
    "&[hidden]": { display: "none" },
  },
};

const SoftwareImageBuilds = () => {
  const [selectedTab, setSelectedTab] = useState("db-software");

  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/apps/tessell/software-images/${selectedTab}/builds`);
  }, [selectedTab]);

  const SOFTWARE_IMAGE_TYPES = ["DB Software", "OS"];

  return (
    <Box sx={fillHeight.mainBox}>
      <Box sx={fillHeight.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => setSelectedTab(newValue)}
              sx={tabbedDataGridPage.tabList}
            >
              {SOFTWARE_IMAGE_TYPES?.map((swiType, i) => (
                <Tab
                  key={i}
                  label={swiType}
                  value={toKebabCase(swiType?.toLowerCase())}
                  icon={<></>}
                  iconPosition="end"
                />
              ))}
            </TabList>
          </Box>
          {SOFTWARE_IMAGE_TYPES?.map((swiType, i) => (
            <TabPanel
              key={i}
              value={toKebabCase(swiType?.toLowerCase())}
              sx={fillHeight.tabPanel}
            >
              {swiType === "DB Software" ? <DbSoftwareBuilds /> : <OsBuilds />}
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default SoftwareImageBuilds;
